import React from "react";
import { TagsStub, BigBlockStub } from "Layouts/Stubs";
import { PaddingBottom, PaddingTop } from "ComponentsUI/Spacings";

const StubTariffsTags = (props) => {
	return (
		<PaddingTop>
			<TagsStub
				search={props.search}
				amount={props.tagsList}
				sort={props.sort}
				tagsList={!!props.tagsList}
			/>
			<PaddingBottom>
				<BigBlockStub />
			</PaddingBottom>
		</PaddingTop>
	);
};

export default StubTariffsTags;
